import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-25" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_4 = {
  key: 0,
  class: "mt-3 text-darkgray-800 leading-7"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "max-h-[150px] overflow-y-auto"
}
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = { class: "font-bold pl-4 mx-auto pr-5 text-primary-500" }
const _hoisted_9 = { class: "font-bold pl-4 mx-auto pr-5 text-red-500" }

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    width: {
        type: String,
    },
    errors : {
        type: Array,
        default: () => {
            return [];
        }
    }
},
  setup(__props) {

const props = __props

const viewErrors = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: __props.show,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
        class: "relative z-10"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([__props.width, "transform overflow-hidden rounded bg-white py-16 px-14 text-center align-middle transition-all"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), {
                        as: "p",
                        class: "text-xl font-bold text-red-500"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.title), 1)
                        ]),
                        _: 1
                      }),
                      (!viewErrors.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (__props.content)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.content), 1))
                              : _createCommentVNode("", true),
                            _renderSlot(_ctx.$slots, "content")
                          ]))
                        : _createCommentVNode("", true),
                      (viewErrors.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: index,
                                  class: "text-red-500"
                                }, _toDisplayString(error[0]), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, [
                        (Object.keys(__props.errors).length !== 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (viewErrors.value = !viewErrors.value)),
                              type: 'button',
                              class: "mr-2 inline-flex items-center text-center justify-center border-solid border-primary-500 border-2 h-[50px] rounded-full pl-2 transition-colors ease-in relative focus:border-primary-500 focus:after:opacity-0 after:absolute after:left-0 after:w-[70%] after:h-full after:z-[-1] after:rounded-l-full after:opacity-0 after:transition-all after:duration-300 after:bg-gradient-to-r after:from-white/50 after:to-transparent hover:after:opacity-100 hover:after:z-10 disabled:after:opacity-0 disabled:bg-neutral-200 disabled:border-primary-500"
                            }, [
                              _createElementVNode("span", _hoisted_8, _toDisplayString(viewErrors.value ? 'Hide Errors' : 'View Errors'), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                          type: 'button',
                          class: "inline-flex items-center text-center justify-center border-solid border-red-500 border-2 h-[50px] rounded-full pl-2 transition-colors ease-in relative focus:border-red-500 focus:after:opacity-0 after:absolute after:left-0 after:w-[70%] after:h-full after:z-[-1] after:rounded-l-full after:opacity-0 after:transition-all after:duration-300 after:bg-gradient-to-r after:from-white/50 after:to-transparent hover:after:opacity-100 hover:after:z-10 disabled:after:opacity-0 disabled:bg-neutral-200 disabled:border-red-500"
                        }, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(__props.cancelText), 1)
                        ])
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})